import useSWR, { SWRConfiguration } from 'swr';
import { AxiosError } from 'axios';
import { getAssignmentByPropertyId } from '../../../providers/api/assignment/assignmentProvider';
import { Assignment } from '../../../providers/api/dtos/assignment';
import { ASSIGNMENT_RID } from '../../../assignment/hooks/use-assignment-by-id/useAssignmentById';
import { SWRCustomResponse } from '../../../hooks/types';
import { useMatchMutate } from '../../../utils/swr/swr';

export const ASSIGNMENT_BY_PROPERTY_ID_RID = [ASSIGNMENT_RID, 'property'];

export default function useAssignmentByPropertyId(
  propertyId?: number | null | undefined,
  options?: SWRConfiguration<Assignment, AxiosError>,
): SWRCustomResponse<Assignment, AxiosError> {
  const matchMutate = useMatchMutate();
  const key = propertyId ? [...ASSIGNMENT_BY_PROPERTY_ID_RID, propertyId] : null;

  const result = useSWR(key, () => getAssignmentByPropertyId(propertyId!), options);

  return ({
    ...result,
    mutate: () => matchMutate(ASSIGNMENT_RID),
  });
}
